import { render } from "./HistorySvg.vue?vue&type=template&id=1044ab65"
import script from "./HistorySvg.vue?vue&type=script&lang=js"
export * from "./HistorySvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__